export enum SIDECAR_ROUTES {
  Organization = 'organization',
}
